import styled from 'styled-components';

export interface AbsoluteDivProps {
  top?: number;
  left?: number;
  right?: number;
  bottom?: number;
  width?: string;
  cursor?: 'pointer' | 'help' | 'wait' | 'crosshair' | 'not-allowed' | 'zoom-in' | 'grab';
}

export const AbsoluteDiv = styled.div<AbsoluteDivProps>`
  position: absolute;
  width: ${({ width }) => (width ? width : '100%')};
  cursor: ${({ cursor }) => (cursor ? cursor : 'default')};
  top: ${({ top }) => `${top}px` || '0'};
  left: ${({ left }) => `${left}px` || '0'};
  right: ${({ right }) => `${right}px` || '0'};
  bottom: ${({ bottom }) => `${bottom}px` || '0'};
`;
